import React, { Component } from 'react'
import { connect } from 'react-redux'
import './estimation.scss'

import Part from '../Part'
import Photo from '../Photo'
import Comment from '../Comment'
import EstimationExtents from './EstimationExtents'
import Line from './../Line'
import PriceApprovalModal from '../../../modals/PriceApprovalModal'
import ConfirmPriceChanges from '../../../components/ConfirmPricechanges'
import Portal from '../../../components/Portal'
// import EstimationsList from '../../../components/EstimationsList'
import DecimalInput from '../../DecimalInput'

import RPReportFiles from '../RPReportFiles'
import RejectEvaluationModal from '../../../modals/RejectEvaluationModal'
import Confirm from '../../Confirm'

import { translation } from '../../../../utils/helpers'
import { hasAccess, hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../../../utils/auth'

import { setCarActiveState } from '../../../../actions/car'
import { getPrices } from '../../../../actions/orderPrice'
import { resetReport } from '../../../../actions/orders'
import { triggerPopup } from '../../../../actions/backdrop'
import { showPopupParts } from '../../../../actions/price'

// Elements
import Button from '../../../elements/button'
import Radio from '../../../elements/radio'
import LabelWrapper from '../../../elements/labelWrapper'
import PanelHeader from '../../../elements/panelHeader'

// constants
import { AssessmentReporType, AssessmentSystemType } from '../../../../constants'
class Estimation extends Component {
  constructor (props) {
    super(props)
    this.state = {
      price: props.orderPrice !== undefined ? props.orderPrice : null,
      order: props.order !== undefined ? props.order : null,
      renderEstimationForForsi: false,
      // shopMustApprove: null,
      confirmDialog: {
        open: false
      },
      rejection: {
        open: false,
        id: -1
      },
      extentIndicationType: 0,
      extentIndicationConfirm: {
        open: false
      }
    }

    this.orderpriceSave = this.orderpriceSave.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.onDelete = this.onDelete.bind(this)
    this.backToWorkcard = this.backToWorkcard.bind(this)
    this.onPortalClose = this.onPortalClose.bind(this)
    this.orderpriceSave = this.orderpriceSave.bind(this)
  }

  componentDidMount () {
    if (this.props.onRef !== undefined) this.props.onRef(this)
    // let order = null
    // if (this.props.order !== undefined) {
    //   order = this.props.order
    // }
    const isEvaluation = this.props.orderPrice.IsEvaluation && this.props.router !== undefined && this.props.router.params !== undefined && this.props.router.params.addon === '3'
    const isAfterEvaluation = this.props.orderPrice.IsAfterEvaluation
    let hasReport = this.props.order && this.props.order.Report && [AssessmentReporType.ForsiManual, AssessmentReporType.DBS].includes(this.props.order.Report.ReportType)
    if (hasReport && !this.props.orderPrice.IsAddonPrice && !isEvaluation && !isAfterEvaluation) {
      this.setState({
        extentIndicationType: 1
      }, () => {
        this.props.setCarActiveState(false)
      })
    }
  }

  componentWillUnmount () {
    if (this.props.onRef !== undefined) this.props.onRef(undefined)
  }

  componentWillReceiveProps (next) {
    let orderPrice = null
    let order = null
    if (next.orderPrice !== undefined) {
      orderPrice = next.orderPrice
    } else if (this.state.orderPrice === null && this.props.orderPrice !== undefined) {
      orderPrice = this.props.orderPrice
    }

    if (next.order !== undefined) {
      order = next.order
    } else if (this.state.order === null && this.props.order !== undefined) {
      order = this.props.order
    }

    let renderEstimationForForsi = false
    if (this.props.useSelectedEvaluation && orderPrice !== null && this.props.renderAdditional === true /* && orderPrice.OrderId === 0 */ && order.Report !== null && [4, 5, 6, 7].includes(order.SelectedEvaluationType)) {
      // This is an empty orderprice only containing parts for selected evaluation. Should render component like for after evaluations.
      // orderPrice.IsAfterEvaluation = true
      renderEstimationForForsi = true
    }

    this.setState({
      price: orderPrice,
      order: order,
      renderEstimationForForsi: renderEstimationForForsi
    })
  }

  getTitle () {
    if (this.props.orderPrice === null) return null
    if (this.props.orderPrice.IsAddonPrice) {
      return translation(1396)
    }

    if (this.props.useSelectedEvaluation === true) {
      if (this.props.orderPrice.IsEvaluation && this.props.order.SelectedEvaluationType === 3) {
        return translation(13363)
      }
      if (this.props.orderPrice.IsAfterEvaluation && this.props.order.SelectedEvaluationType === 4) {
        return translation(14921)
      }
    }
    switch (this.props.order.OrderType) {
      case 1:
        return translation(13360)
      case 2:
        return translation(71)
      case 3:
        return translation(13361)
      case 6:
        return translation(785)
    }
    return 'No title'
  }

  getTitleAria () {
    if (this.props.orderPrice === null) return null
    if (this.props.orderPrice.IsAddonPrice) {
      return translation(34) + ' ' + translation(1396)
    }
    return translation(2705)
  }

  getIcon () {
    if (this.props.orderPrice === null) return null
    if (this.props.orderPrice.IsAddonPrice) {
      return '/images/svgs/taksering/Additional-sales-new.svg'
    }
    switch (this.props.order.OrderType) {
      case 1:
        return '/images/svgs/ordrer/Insurance-black.svg'
      case 2:
        return '/images/svgs/ordrer/Salescar-black.svg'
      case 3:
        return '/images/svgs/ordrer/Garanteed-black.svg'
      case 6:
        return '/images/svgs/ordrer/Private_c-black.svg'
    }
    return null
  }

  getEditUrl () {
    if (this.props.orderPrice === null) return null
    if ((this.props.orderPrice.UseEstimation && !this.props.orderPrice.IsAfterEvaluation && !this.props.orderPrice.IsEvaluation) || this.props.order.OrderType === 1) {
      if (this.props.order !== null && (this.props.department === 0 && this.props.order.IsAssessmentOk === true) || (this.props.department === 1 && this.props.order.IsBodyShopAssessmentOk)) return null
      // if (this.props.order !== null && this.props.order.IsReferredIn === true) return null
      if (this.props.order !== null && (hasAccess([4], this.props.auth.user.UserType) || hasAccess([3, 5, 7], this.props.auth.user.UserType) && this.props.auth.user.DepartmentType === 1) && this.props.order.IsDraft !== true && this.props.orderPrice.Department === 0) return null
    }
    if (hasAccess([6], this.props.auth.user.UserType)) return null
    if (this.props.orderPrice.IsAfterEvaluation || this.props.orderPrice.IsEvaluation) return null

    return '/pricecalculation/' + this.props.order.Id + '/1'
  }

  orderpriceSave (e) {
    let name = e.name === 'Price' ? 'Total' : e.name
    this.setState({
      price: {
        ...this.state.price,
        [name]: e.value
      }
    }, () => {
      this.props.saveOrderPrice(this.state.price)
    })
  }

  onInputChange (e) {
    let property = e.target.name === 'Price' ? 'Total' : e.target.name
    this.setState({
      price: {
        ...this.state.price,
        [property]: e.target.value
      }
    })
  }

  renderExtentIndication () {
    if (!hasSubscriptionPermission(this.props.auth, 10)) return null
    if (this.state.price.IsEvaluation || this.state.price.IsAfterEvaluation || this.state.price.IsAddonPrice) return null

    const onChange = e => {
      let { name, value } = e.target
      value = parseInt(value, 10)

      if (value === 1) {
        this.props.showPopupParts(false)
      }

      let hasReport = this.props.order.Report !== null && [AssessmentReporType.ForsiManual, AssessmentReporType.DBS].includes(this.props.order.Report.ReportType)
      // if (value === 0 && this.props.order.RpReport !== null) {
      if (value === 0 && hasReport) {
        return this.setState({
          extentIndicationConfirm: {
            ...this.state.extentIndicationConfirm,
            open: true
          }
        })
      }

      this.setState({
        [name]: value
      },
      () => {
        this.props.setCarActiveState(this.state.extentIndicationType !== 1)
      })
    }

    const onConfirm = () => {
      this.props.resetReport(this.props.order.Id).then(() => {
        this.props.loadOrder(true).then(() => {
          this.setState({
            extentIndicationType: 0,
            extentIndicationConfirm: {
              ...this.state.extentIndicationConfirm,
              open: false
            }
          },
          () => {
            // Get updated orderPrice
            this.props.getPrices(this.props.order.Id, false, false, false, false, false, false, false, 0, true)
            this.props.setCarActiveState(true)
          })
        })
      })
    }

    const onNotConfirm = () => {
      this.setState({
        extentIndicationConfirm: {
          ...this.state.extentIndicationConfirm,
          open: false
        }
      })
    }

    let assessmentEnable = [AssessmentSystemType.Forsi, AssessmentSystemType.DBS].includes(this.props.auth.permissions.ChainAssessmentSystem)
    return (
      <div>
        {assessmentEnable && <LabelWrapper labelText={15275}>
          <Radio id='estimation' name='extentIndicationType' labelText={15277} value={0} onChange={onChange} checked={this.state.extentIndicationType === 0} />
          <Radio id='report' name='extentIndicationType' labelText={15276} value={1} onChange={onChange} checked={this.state.extentIndicationType === 1} />
        </LabelWrapper>}
        {this.state.extentIndicationConfirm.open && (
          <Confirm confirm={onConfirm.bind(this)} notConfirm={onNotConfirm.bind(this)} renderText={() => translation('15282')} t={translation} />
        )}
      </div>
    )
  }

  renderReportUpload () {
    if (this.state.order === null) return null
    if (this.state.extentIndicationType === 0) return null

    const onBlur = (args) => {
      if (this.props.order[args.name] !== undefined && this.props.order[args.name] !== args.value) {
        let data = {
          OrderID: this.props.order.Id,
          Other: {
            [args.name]: args.value,
            IsDirty: true
          }
        }
        this.props.saveOrder(data)
      }
    }

    const renderManualPriceLines = () => {
      if (this.props.order.ReportType === AssessmentReporType.DBS) return null // use to hide manual paint price

      return (
        <div>
          <div className='title'>{translation('1913')}</div>
          <DecimalInput labelText={641} name='Price' onBlur={onBlur} value={this.state.order.Price || 0} rightAlign />
          <DecimalInput labelText={15195} name='Environment' onBlur={onBlur} value={this.state.order.Environment || 0} rightAlign />
        </div>
      )
    }
    return (
      <div className='white__box'>
        {renderManualPriceLines()}
        {this.renderRPReportFiles()}
        <Button labelText={956} onClick={this.props.goBack} />
      </div>
    )
  }

  renderManualPriceEdit () {
    if (this.state.order === null) return null
    if (this.state.price.IsEvaluation || this.state.price.IsAfterEvaluation || !this.props.editable) return null
    if (this.state.extentIndicationType === 1) return null

    return (
      <div>
        <PanelHeader text={translation('1913')} />
        <DecimalInput labelText={translation('641')} name='Price' onBlur={this.orderpriceSave} onChange={this.onInputChange} value={this.state.price.Total} rightAlign />
        <DecimalInput labelText={translation('13339')} name='Environment' onBlur={this.orderpriceSave} onChange={this.onInputChange} value={this.state.price.Environment} rightAlign />
      </div>
    )
  }

  renderManualPrice () {
    if (!this.props.order || !this.props.order.ShowPrices) return null
    if (this.props.editable || this.state.price.IsAfterEvaluation || this.state.price.IsEvaluation || this.state.renderEstimationForForsi) return null

    return (
      <div>
        <Line text={translation('641') + ':'} amount={this.state.price.Total || '0,00'} />
        <Line text={translation('13339') + ':'} amount={this.state.price.Environment || '0,00'} />
      </div>
    )

    // return (
    //   <div>
    //     <div className='clearfix control__group'>
    //       <label>{translation('641')}</label>
    //       <span>{this.state.price.Total || '0,00'}</span>
    //     </div>

    //     <div className='clearfix control__group'>
    //       <label>{translation('13339')}</label>
    //       <span>{this.state.price.Environment || '0,00'}</span>
    //     </div>
    //   </div>
    // )
  }

  onDelete (OrderEstimationTaskId) {
    let parts = this.state.price.Parts.map(part => {
      let task = part.EstimationTasks.filter(task => task.OrderEstimationTaskId === OrderEstimationTaskId)
      if (typeof task[0] === 'object') task[0].IsDeleted = true
      return part
    })

    this.setState({
      price: {
        ...this.state.price,
        Parts: parts
      }
    }, () => this.props.saveOrderPrice(this.state.price))
  }

  // Back to workcard function
  backToWorkcard () {
    let orderPrice = this.props.orderPrice
    const confirmChangeAndGoBack = () => {
      if ((orderPrice.IsEvaluation || !this.props.order.IsDraft)/*  && !orderPrice.IsAddonPrice */) {
        // console.log('RequireShopApproval', this.props.orderPrice.RequireShopApproval)
        if (this.props.orderPrice.RequireShopApproval || (this.props.orderPrice.IsAfterEvaluation && this.props.orderPrice.HasChanged)) {
          this.props.triggerPopup(true)
          this.setState({
            // shopMustApprove: true,
            confirmDialog: {
              // mustApprove: true,
              open: true
            }
          })
        } else {
          this.props.goBack()
        }
      } else {
        this.props.goBack()
      }
    }

    if (this.props.editable) {
      setTimeout(() => {
        // Price/price changes
        let orderPrice = this.props.orderPrice
        // if (orderPrice.RequireShopApproval) {
        //   // priceObj.SendToApproval = true
        // }
        if (orderPrice.IsEvaluation && this.props.order.IsDraft) {
          // orderPrice.SendToApproval = true
        }
        // console.log('orderPrice', orderPrice)
        this.props.saveOrderPrice(orderPrice).then(() => {
          confirmChangeAndGoBack()
        })
      }, 800)
    } else {
      this.props.goBack()
    }
  }

  renderConfirm () {
    const onClose = (goBack = true) => {
      this.setState({
        confirmDialog: {
          ...this.state.confirmDialog,
          open: false
        }
      })
      if (goBack) this.props.goBack()
    }

    if (this.state.confirmDialog.open) {
      if (this.props.orderPrice.RequireShopApproval) {
        return (<PriceApprovalModal
          orderId={this.props.order.Id}
          show={this.state.confirmDialog.open && this.props.orderPrice.RequireShopApproval === true}
          RequireCustomerApproval={this.props.orderPrice.RequireCustomerApproval}
          closeModal={onClose.bind(this, false)}
          overflowHidden={false}
          />)
      } else {
        return (
          <Portal className='confirm_popup' onPortalClose={() => { return }}>
            <ConfirmPriceChanges changes={this.props.orderPrice.RequireCustomerApproval} confirm={onClose.bind(this)} />
          </Portal>
        )
      }
    }
  }

  renderAfterevaluation () {
    // console.log('renderAfterevaluation', this.state.price)

    if (!this.state.price.IsAfterEvaluation) return null
    let showHeader = this.props.overrideInnerTitle === undefined ||
                    this.props.overrideInnerTitle === null ||
                    (this.props.overrideInnerTitle !== undefined && this.props.overrideInnerTitle !== null && this.props.overrideInnerTitle.length > 0)
    // if (this.props.isApproval) console.log('Estimation renderAfterevaluation EDITABLE', this.props.editable)
    return (
      <div>
        {showHeader && <PanelHeader text={(this.props.overrideInnerTitle === undefined || this.props.overrideInnerTitle === null) ? translation('1277') : this.props.overrideInnerTitle} />}
        {<EstimationExtents
          renderReport={this.state.price.Report !== null}
          onDelete={this.onDelete}
          editable={this.props.editable}
          orderPrice={this.state.price}
          partTasks={this.props.partTasks}
          saveOrderPrice={this.props.saveOrderPrice}
          currencyCode={this.props.currencyCode}
          order={this.props.order}
          />}
      </div>
    )
  }

  // renderSendToCustomer () {
  //   if (!this.props.editable) return null
  //   if (!this.state.price.IsAfterEvaluation) return null
  //   if (this.state.price.selectedAfterEvaluation) return null
  //   let { price } = this.state
  //   const trigger = () => {
  //     let price = { ...this.state.price }
  //     price.SendToCustomer = !price.SendToCustomer
  //     this.props.saveOrderPrice(price)
  //     this.setState({
  //       hasChanged: true
  //     })
  //   }

  //   price.SendToCustomer = !this.state.hasChanged ? true : price.SendToCustomer

  //   return (
  //     <div>
  //       <PanelHeader text={translation('1022')} />
  //       <Check labelText={translation('1022')} id='SendToCustomer' name='SendToCustomer' onChange={trigger} checked={price.SendToCustomer} />
  //     </div>
  //   )
  // }

  renderParts (includeForsiAssociated = true, onlyAdditional = false) {
    let combinedParts = []
    let parts = this.state.price.Parts
    let additionalParts = this.state.price.AdditionalParts

    parts.forEach(part => {
      combinedParts.push(part)
    })

    const combineArrays = (array1, array2, comparer) => {
      if (array1 === null) array1 = []
      if (array2 === null) array2 = []
      let combined = []
      array1.forEach(item => {
        combined.push(item)
      })
      array2.forEach(item2 => {
        let combinedIndex = combined.findIndex(item1 => comparer(item1, item2))
        if (combinedIndex === -1) {
          combined.push(item2)
        }
      })

      return combined
    }

    // Merge AdditionalParts and Parts array.
    if (additionalParts !== null && additionalParts.length > 0) {
      additionalParts.forEach(part => {
        let combinedPartIndex = combinedParts.findIndex(p => p.Part.PartItemId === part.Part.PartItemId && p.Part.TaskSide === part.Part.TaskSide || p.IsAdditional === part.IsAdditional)
        if (combinedPartIndex > -1) {
          combinedParts[combinedPartIndex].EstimationTasks = combineArrays(combinedParts[combinedPartIndex].EstimationTasks, part.EstimationTasks, (task1, task2) => task1.EstimationTaskId === task2.EstimationTaskId)
        } else {
          combinedParts.push(part)
        }
      })
    }

    return (
      <div>
        {combinedParts.map((val) => {
          return <Part
            key={'part_' + val.Part.PartItemId + '_' + val.Part.TaskSide + (val.IsAdditional ? '_additional' : '')}
            order={this.state.order}
            orderPrice={this.state.price}
            part={val}
            includeForsiAssociatedTasks={!this.props.editable && includeForsiAssociated/* this.state.renderEstimationForForsi */}
            onDelete={this.props.editable === true && this.onDelete}
            onlyAdditionalParts={onlyAdditional}
            editable={this.props.editable}
          />
        })}
      </div>
    )
  }

  renderExtent () {
    if (this.state.price === undefined || this.state.price === null) return
    if (this.state.extentIndicationType === 1) return null
    let css = 'price__view estimation__extent'
    if (this.props.editable) {
      css = 'price__view estimation__extent editable'
    }

    let IsAfterEvaluation = this.state.price.IsAfterEvaluation
    let title = this.props.overrideInnerTitle // <div>&nbsp;</div> // This controls 2nd title, below after evaluation/forsi.

    if (title === undefined || title === null) {
      if (IsAfterEvaluation) {
        title = translation(891)
      } else {
        title = translation(889)
      }
    }

    let hasReport = this.state.price.Report !== null && this.state.price.Report.ReportId !== 0
    // let hasAdditionalTasks = checkHasAddedTasks()

    let hasAdditionalParts = this.state.price.AdditionalParts !== null && this.state.price.AdditionalParts.length > 0
    let isEval = this.state.order !== null &&
      this.state.order.IsEvaluation &&
      this.props.router !== undefined && this.props.router.params !== undefined && this.props.router.params.addon === '3'

    let renderRejectEval = hasAccess([6, 3, 5, 7], this.props.auth.user.UserType) && this.props.editable && isEval && this.state.order.IsEvaluated === false && this.state.order.IsEvaluationRejected === false
    let renderEval = hasAccess([6, 3, 5, 7], this.props.auth.user.UserType) && isEval

    let noteChangeSource = 11
    if (this.state.price.IsAfterEvaluation) noteChangeSource = 7
    if (this.state.price.IsEvaluation) noteChangeSource = 8
    const comment = this.state.price.Notes.find(n => n.SourceID === noteChangeSource)

    let hasCommentAndPhotoAccess = hasSubscriptionPermission(this.props.auth, 10)
    if (this.props.auth.departmentType === 1 && this.props.department === 0 && this.props.auth.hasPartner) {
      hasCommentAndPhotoAccess = hasPartnerSubscriptionPermission(this.props.auth, 10)
    }

    // let includeForsiAssociated = this.props.renderAdditional === true || true
    // let onlyAdditional = true

    let includeForsiAssociated = true
    let onlyAdditional = this.props.renderAdditional

    return (
      <div className={css}>
        {this.props.viewMode === 'mobile' && this.props.renderInside()}
        {this.renderAfterevaluation()}
        {(hasReport || !IsAfterEvaluation) && ((this.props.renderAdditional && hasAdditionalParts) || this.props.editable) && title !== null && <PanelHeader text={title} />}
        <div className='estimationtasks'>
          {this.renderParts(includeForsiAssociated, onlyAdditional)}
        </div>
        {((IsAfterEvaluation && hasReport) || (!this.state.price.IsAfterEvaluation && (this.state.price.UseEstimation || (this.state.order !== undefined && this.state.order !== null && this.state.order.OrderType === 1))) || this.state.price.IsEvaluation) &&
          <EstimationExtents
            editable={this.props.editable}
            orderPrice={this.state.price}
            partTasks={this.props.partTasks}
            saveOrderPrice={this.props.saveOrderPrice}
            currencyCode={this.props.currencyCode}
          />}
        {this.props.editable && hasCommentAndPhotoAccess &&
          <Photo
            saveOrderPrice={this.props.saveOrderPrice}
            orderPrice={this.state.price}
            order={this.state.order}
          />}
        {this.props.editable && hasCommentAndPhotoAccess &&
          <Comment
            comment={comment}
            changeSource={noteChangeSource}
            orderPriceId={this.state.price.OrderPriceId}
            order={this.state.order}
            renderEval={renderEval}
          />}
        {/* this.renderSendToCustomer() */}
        {this.props.editable && this.renderOkButton()}
        {renderRejectEval && this.renderReject()}
        {renderEval && this.state.rejection.open && (
          <RejectEvaluationModal
            orderPrice={this.state.price}
            show={this.state.rejection.open}
            id={this.state.rejection.id}
            updatePrices={this.props.saveOrderPrice}
            onClose={this.onPortalClose}
            goBack={this.props.goBack} />
        )}
      </div>
    )
  }

  renderOkButton () {
    // const goBack = () => {
    //   this.setState({
    //     price: {
    //       ...this.state.price,
    //       SendToApproval: true
    //     }
    //   }, () => {
    //     this.orderpriceSave()
    //     setTimeout(this.props.goBack, 1000)
    //   })
    // }

    let orderPrice = this.props.orderPrice
    if (orderPrice.RequireApproval) {
      return <Button onClick={this.backToWorkcard.bind(this)} labelText={translation('791')} />
    }
    return <Button onClick={this.backToWorkcard} labelText={translation('956')} />
  }

  renderReject () {
    const showRejectModal = () => {
      this.setState({
        rejection: {
          open: true,
          id: -1
        }
      }
        // , () => console.log(this.state.rejection)
      )
    }

    return (
      <div className='reject__link'>
        <a onClick={showRejectModal}>{translation('13716')}</a>
      </div>
    )
  }

  onPortalClose () {
    this.setState({
      rejection: {
        ...this.state.rejection,
        open: false
      }
    })
  }

  renderRPReportFiles (hide = false) {
    if (this.props.order === undefined || hide) return null
    if (!this.props.editable) {
      return (
        <RPReportFiles
          order={this.props.order}
          renderBody={this.props.department === 1}
          renderPaint={this.props.department === 0}
          showDates
          />
      )
    } else {
      return (
        <RPReportFiles
          order={this.props.order}
          editable
          renderPaint
          renderBody
          renderSparePart
          onUploadSuccess={this.props.loadOrder.bind(this, true)}
        />
      )
    }
  }

  render () {
    // if (this.props.isApproval) console.log('Estimation state.price', this.state.price)
    if (!this.state.price) return null

    return (
      <div>
        {this.renderRPReportFiles(true)}
        {this.props.editable && this.renderExtentIndication()}
        {this.props.editable && this.renderReportUpload()}
        {this.renderManualPriceEdit()}
        {this.renderExtent()}
        {this.renderManualPrice()}
        {this.renderConfirm()}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    currencyCode: state.common.currencyCode
  }
}

export default connect(mapStateToProps, {
  triggerPopup,
  getPrices,
  resetReport,
  setCarActiveState,
  showPopupParts
})(Estimation)



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/Estimation/index.js